import React from 'react'
import rating from '../images/rating.png';
import homebg from '../images/homebg.png';
import homerightImage from '../images/home-right.webp';
import marketing2 from '../images/Hrias-video-thumb.jpg';
import marketing3 from '../images/Hrias-video.mp4';
import { FaStar, FaPlay } from "react-icons/fa";
import Swal from "sweetalert2";

function CaseStudyHriasB2B() {

  const testimonials = [
    {
      img: "https://i.pravatar.cc/120?img=1",
      rating: 5,
      title: "$1,000,000+ in Sales in 6 months",
      text: "Over the past six months HRias has directly contributed to new revenue exceeding $1 million. The platform has become an essential tool in our marketing strategy.",
      name: "Emma Collins",
      position: "Marketing Manager",
      company: "NexaTech Solutions",
    },
    {
      img: "https://www.uplead.com/wp-content/uploads/2023/10/chris-neill-uplead.png?img=2",
      rating: 5,
      title: "535% ROI & 30% Increase in Revenue",
      text: "Using HRias allowed us to increase revenue by 30%. The leads have been accurate and up to date.",
      name: "Liam Parker",
      position: "CEO",
      company: "BrandLoop Media",
    },
    {
      img: "https://i.pravatar.cc/120?img=3",
      rating: 5,
      title: "$150,000 in Sales in 60 Days",
      text: "Now that we have verified contact data, our team can focus completely on closing deals.",
      name: "Olivia Turner",
      position: "Sales Head",
      company: "OrbitX CRM",
    },
    {
      img: "https://www.uplead.com/wp-content/uploads/2023/10/danined-midura-uplead.png?img=4",
      rating: 5,
      title: "1,567% ROI using HRias",
      text: "Affordable, reliable data and amazing customer support. Highly recommended.",
      name: "Sophia Bennett",
      position: "Founder",
      company: "DigitalGrow Labs",
    },
    {
      img: "https://i.pravatar.cc/120?img=5",
      rating: 5,
      title: "$400k+ Pipeline Growth",
      text: "We switched from expensive platforms — HRias is more accurate and cost-efficient.",
      name: "Noah Mitchell",
      position: "Business Consultant",
      company: "MarketBridge Pro",
    },
    {
      img: "https://www.uplead.com/wp-content/uploads/2023/10/karen-p-storey-uplead.png?img=6",
      rating: 5,
      title: "$100k+ Revenue & 12,526% ROI",
      text: "Pricing + accuracy made HRias the perfect choice for our business.",
      name: "Ava Richardson",
      position: "Co-Founder",
      company: "EduSphere Academy",
    },
    {
      img: "https://i.pravatar.cc/120?img=7",
      rating: 5,
      title: "65% Increase in Revenue",
      text: "Reply rate reached 80% using verified HRias emails. Massive game changer.",
      name: "Ethan Walker",
      position: "Product Lead",
      company: "SoftPulse ERP",
    },
    {
      img: "https://i.pravatar.cc/120?img=8",
      rating: 5,
      title: "Best Lead Tool We’ve Used!",
      text: "Coverage is excellent — far better than other platforms we tested.",
      name: "Isabella Carter",
      position: "Growth Specialist",
      company: "Adverto Media",
    },
    {
      img: "https://i.pravatar.cc/120?img=9",
      rating: 5,
      title: "Finding Decision Makers Easily",
      text: "Simple, powerful, and accurate. HRias makes lead generation effortless.",
      name: "Mason Reed",
      position: "Founder",
      company: "ReachFlow Solutions",
    },
    {
      img: "https://i.pravatar.cc/120?img=10",
      rating: 5,
      title: "Feature Packed Yet Simple",
      text: "Perfect balance of features and usability. Fully recommended.",
      name: "Charlotte Hayes",
      position: "Campaign Manager",
      company: "PixelHive Co.",
    },
    {
      img: "https://i.pravatar.cc/120?img=11",
      rating: 5,
      title: "Accurate & Up-To-Date Data",
      text: "Bounce rate almost zero — data quality is exceptional.",
      name: "James Cooper",
      position: "Founder",
      company: "StartupNest Global",
    },
    {
      img: "https://i.pravatar.cc/120?img=12",
      rating: 5,
      title: "Best Alternative to Expensive Tools",
      text: "HRias is easy to use and incredibly efficient for targeted lists.",
      name: "Grace Morgan",
      position: "BDM",
      company: "TechVault Solutions",
    },
    {
      img: "https://i.pravatar.cc/120?img=13",
      rating: 5,
      title: "The Data Is Always Fresh",
      text: "Accurate contact details helped us reach the right prospects instantly.",
      name: "Benjamin Scott",
      position: "Marketing Lead",
      company: "Adset Digital",
    },
    {
      img: "https://i.pravatar.cc/120?img=14",
      rating: 5,
      title: "Easy to Use & Powerful",
      text: "A simple yet powerful platform that gives exactly what sales teams need.",
      name: "Daniel Brooks",
      position: "Operations Manager",
      company: "BlueBox Systems",
    },
  ];

  const openVideoPopup = () => {
    Swal.fire({
      html: `
          <div style="position: relative;">
            <iframe
              width="50%"
              height="350"
              src=${marketing3} type="video/mp4"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
              style="border-radius:10px;"
            ></iframe>
          </div>
        `,
      background: "#111",
      width: 750,
      padding: 0,
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: "video-popup-style",
        closeButton: "video-popup-close"
      }
    });
  };


  return (
    <><section
      id="home"
      style={{
        backgroundImage: `url(${homebg})`,
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 ">
            <h1 className="display-4 fw-bold ">Discover what<span className="highlight-orange"> our customers </span>  have to say! <img
              src={rating}
              alt="Best Software Solution in UAE"
              style={{ height: '65px', marginLeft: '10px', verticalAlign: 'middle' }} /></h1>
            <p className="lead ">
              Hrias by Peregrinee is a best-in-class lead generation platform that allows you to build highly targeted ready to buy B2B lists . Read our Hrias by Peregrinee reviews to learn why companies worldwide trust and use Hrias by Peregrinee.
            </p>
            {/* <p className="lead">
      <h1 className="fw-bold "><span className="highlight-orange">Why </span>Partner<span className="highlight-orange"> With</span>  Us?</h1>
      <ul className="mt-3">
        <li>100% Money Back Guarantee if We Can't Deliver Results</li>
        <li>We Build Software Exactly as Per Your Budget</li>
      </ul>
    </p> */}
            <div className="row mt-4">
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <a href="/contact-us-hrias" className="btn custom-orange-btn w-100 py-3 px-4 fw-bold">Contact Sales</a>
              </div>
              {/* <div className="col-12 col-md-6">
      <a href="#contact-us" className="btn custom-orange-btn-outline w-100 py-3 px-4 fw-bold">Book a Free Consultation</a>
    </div> */}
            </div>

            {/* <div className="row mt-5">
      {[
        { title: '350+', desc: 'Clients' },
        { title: '8', desc: 'Countries' },
        { title: '15+', desc: 'Industries' }
      ].map((item, idx) => (
        <div className="col-12 col-md-4 mb-4" key={idx}>
          <div className="info-card text-center p-4 h-100">
            <h2 className="fw-bold mb-2" style={{ color: '#ff6600' }}>{item.title}</h2>
            <p className="mb-0 fs-4 fw-bold">{item.desc}</p>
          </div>
        </div>
      ))}
    </div> */}

          </div>

          {/* Right column - You can add an image, text, or anything here */}
          <div className="col-md-6"
          >
            <img src={homerightImage} alt="#1 Software Development Service" className="img-fluid" />
            {/* <div className="lead-form-wrapper">
      <LeadForm />
    </div> */}
          </div>
        </div>
      </div>
    </section>

      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Wall of Love</h2>

        {/* <section className="container my-5">
          <div className="row align-items-center">

            <div className="col-md-6 position-relative text-center">
              <img
                src={marketing2}
                alt="Case Study Thumbnail"
                className="rounded shadow"
                style={{ maxWidth: "60%", height: "auto" }}
              />


              <div
                onClick={openVideoPopup}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  background: "rgba(0,0,0,0.5)",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  transition: "0.3s"
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.7)")}
                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.5)")}
              >
                <FaPlay style={{ fontSize: "32px", color: "#fff" }} />
              </div>
            </div>

            <div className="col-md-6 mt-4 mt-md-0">
              <p className="fw-bold" style={{ color: "#0d6efd", fontSize: '20px' }}>Case Study</p>

              <h1 className="fw-bold" style={{ lineHeight: "1.3" }}>
                <span style={{ color: "#0d6efd" }}>Nervana Co.</span> Generates <span style={{ color: "#0d6efd" }}>$300k</span> in Pipeline and Achieves <span style={{ color: "#0d6efd" }}>89% ROI</span> with <span style={{ color: "#0d6efd" }}>Hrias by Peregrinee</span>
              </h1>

              <button
                onClick={openVideoPopup}
                className="btn btn-primary mt-4"
                style={{
                  backgroundColor: "#134373",
                  borderRadius: "25px",
                  border: "none",
                  padding: "12px 28px",
                  fontWeight: "600"
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dc")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#134373")}
              >
                Watch Case Study
              </button>
            </div>
          </div>

          <style>{`
        .video-popup-close {
          color: white !important;
          font-size: 22px !important;
          position: absolute !important;
          top: 10px !important;
          right: 12px !important;
        }
        .video-popup-style {
          border-radius: 12px !important;
        }
      `}</style>
        </section> */}

        <div className="row g-4">
          {testimonials.map((t, index) => (
            <div key={index} className="col-md-6">
              <div className="p-4 shadow rounded bg-white d-flex gap-3">
                <img
                  src={t.img}
                  alt="profile"
                  className="rounded-circle"
                  style={{ width: "70px", height: "70px", objectFit: "cover" }}
                />

                <div>
                  <div className="text-warning mb-1">
                    {[...Array(t.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>

                  <h5 className="fw-semibold">{t.title}</h5>
                  <p className="text-muted">{t.text}</p>

                  <p className="fw-bold mb-0">{t.name}</p>
                  <p className="text-muted mb-0">
                    {t.position} — {t.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>


    </>

  )
}

export default CaseStudyHriasB2B